/* Preserve storefront language when opening the withdrawal app. */
(() => {
 const config = document.currentScript;
 const root = (config.dataset.root || '/').replace(/\/$/, '');
 const locale = config.dataset.locale;
 const country = config.dataset.country;
 function localize(link) {
  if (!link || !link.href) return;
  let url;
  try { url = new URL(link.href, location.href); } catch { return; }
  if (url.origin !== location.origin || !/\/a\/withdrawal\/?$/.test(url.pathname)) return;
  url.pathname = root + '/a/withdrawal';
  url.searchParams.set('locale', locale);
  if (country) url.searchParams.set('country', country);
  if (link.href !== url.href) link.href = url.href;
 }
 function scan(node) {
  if (node.nodeType !== 1) return;
  if (node.matches('a[href]')) localize(node);
  node.querySelectorAll('a[href*="/a/withdrawal"]').forEach(localize);
 }
 scan(document.documentElement);
 new MutationObserver(records => records.forEach(record => {
  if (record.type === 'attributes') localize(record.target);
  record.addedNodes.forEach(scan);
 })).observe(document.documentElement, {childList:true,subtree:true,attributes:true,attributeFilter:['href']});
 document.addEventListener('click', event => {
  const link = event.target.closest && event.target.closest('a[href]');
  localize(link);
 }, true);
})();